import {StyleSheet} from 'react-native';

import {MAX_CONTENT_WIDTH} from '/constant/data.constant';
import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: white,
    flex: 1,
    width: '100%' as const,
    maxWidth: MAX_CONTENT_WIDTH as number,
    alignSelf: 'center' as const,
  },
  header: {
    minHeight: 0,
    paddingTop: 0,
    paddingBottom: 0,
  },
  arrangedIcons: {
    marginVertical: 0,
  },
  iconsGap: {
    flex: 0,
  },
  featureFeedback: {
    marginTop: 10,
  },
});
